import request from '@/utils/request'

// 查询积分列表
export function queryIntegralList(params) {
	console.log("进入查询")
	return new Promise((resolve, reject) => {
		request({
			url: '/jymall.getGoodsType',
			method: 'get',
			params
		}).then(response => {
			const res = response.data
			if (res.length != 0) {
				resolve({
					data: res,
					total: res.length
				})
			} else {
				reject(new Error(res.msg || '查询失败'))
			}

		}).catch(error => {
			reject(error)
		})
	})
}